import React from "react";
import { AlertCircle, CheckCircle2, X } from "lucide-react";

export default function AuthPopup({
  open,
  type = "error",
  title,
  message,
  buttonText = "OK",
  onClose,
}) {
  if (!open) return null;

  const isSuccess = type === "success";

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-white/40 backdrop-blur-[3px]"
        onClick={onClose}
      />

      <div className="relative w-full max-w-[390px] rounded-[22px] border border-[#f2c6cc] bg-white p-7 text-center shadow-[0_24px_80px_rgba(216,106,120,0.22)]">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-1 text-slate-400 hover:bg-[#fff3f5] hover:text-[#d86a78]"
        >
          <X size={18} />
        </button>

        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#fff3f5] text-[#d86a78]">
          {isSuccess ? <CheckCircle2 size={34} /> : <AlertCircle size={34} />}
        </div>

        <h3 className="text-[20px] font-bold tracking-wide text-[#d86a78]">
          {title || (isSuccess ? "SUCCESS" : "ALERT")}
        </h3>

        <p className="mt-3 text-[13px] leading-6 text-slate-500">
          {message}
        </p>

        <button
          type="button"
          onClick={onClose}
          className="mt-7 h-[44px] w-full rounded-[10px] bg-[#d86a78] text-[13px] font-semibold text-white shadow-[0_12px_26px_rgba(216,106,120,0.22)] hover:bg-[#c95b69]"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}